import type {Gltf, Image} from './assets-type'
import {path} from './assets-type'

export const shieldAssets = {
  gltfs: {
    shield: {
      src: `${path}/mascot/shield/shield.glb`,
      scene: null,
    },
  } as {[key: string]: Gltf},
  images: {
    matcap_mascot: {
      src: `${path}/matcaps/mascot.jpg`,
      texture: null,
      flipY: false,
    },
    star: {
      src: `${path}/textures/star.jpg`,
      texture: null,
      flipY: false,
    },
    shield_sss: {
      src: `${path}/mascot/shield/textures/shield_sss.jpg`,
      texture: null,
      flipY: false,
    },
    shield_diffuse: {
      src: `${path}/mascot/shield/textures/shield_diffuse.jpg`,
      texture: null,
      flipY: false,
    },
    shield_blur: {
      src: `${path}/mascot/shield/textures/shield_blur.jpg`,
      texture: null,
      flipY: true,
    },
  } as {[key: string]: Image},
}
